import { Injectable, Inject } from '@angular/core';
import { SessionService, AuthenticationService, UpdateSessionPayload, RedirectedUserSessionData, SessionDataMapped } from '@airtradeit/authentication';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@store/state';
import { tap } from 'rxjs/operators';

import * as SessionActions from '@store/session/session.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    @Inject(SessionService) private _sessionService: SessionService,
    @Inject(AuthenticationService) private _authenticationService: AuthenticationService,
    @Inject(Store) private _store: Store<AppState>
  ) {}

  retrieveAndStoreSession(): Observable<SessionDataMapped> {
    return this._sessionService.retrieveSessionData().pipe(tap(this.storeSession));
  }

  updateAndStoreSession(payload: UpdateSessionPayload): Observable<SessionDataMapped> {
    return this._sessionService.updateSessionData(payload).pipe(tap(this.storeSession));
  }

  authenticateUser(authState: string, authCode: string): Observable<SessionDataMapped> {
    return this._authenticationService.authenticateUser(authState, authCode).pipe(tap(this.storeSession));
  }

  retrieveRedirectedUserSession({ bearerToken, selectedAffiliate, cultureCode }: RedirectedUserSessionData): Observable<SessionDataMapped> {
    return this._authenticationService
      .retrieveRedirectedUserSession({ bearerToken, selectedAffiliate, cultureCode })
      .pipe(tap(this.storeSession));
  }

  storeSession = (data: SessionDataMapped): void => {
    this._store.dispatch(SessionActions.setSession({ data }));
  }
}
